export default __webpack_public_path__ + "static/media/chart-lp.f52d11b5.png";